
import { Routes, Route, Outlet } from "react-router-dom";
import { NavigationWrapper } from "./NavigationWrapper";
import { ProtectedRoute } from "./ProtectedRoute";
import Index from "@/pages/Index";
import Mission from "@/pages/Mission";
import Work from "@/pages/Work";
import Board from "@/pages/Board";
import Contact from "@/pages/Contact";
import ChatBot from "@/pages/ChatBot";
import Membership from "@/pages/Membership";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminArticles from "@/pages/AdminArticles";
import AdminArticlesList from "@/pages/AdminArticlesList";
import AdminAIArticles from "@/pages/AdminAIArticles";
import AdminGallery from "@/pages/AdminGallery";
import AdminImageStudio from "@/pages/AdminImageStudio";
import AdminContactSubmissions from "@/pages/AdminContactSubmissions";
import AdminMembershipApplications from "@/pages/AdminMembershipApplications";
import AdminEmailBuilder from "@/pages/AdminEmailBuilder";
import AdminEmailTemplates from "@/pages/AdminEmailTemplates";
import AdminProfile from "@/pages/AdminProfile";
import AdminKnowledgeBase from "@/pages/AdminKnowledgeBase";
import Auth from "@/pages/Auth";
import ArticleDetail from "@/pages/ArticleDetail";
import AdminChatHistory from "@/pages/AdminChatHistory";
import AdminSurveyResults from "@/pages/AdminSurveyResults";
import AdminSurveyReportTest from "@/pages/AdminSurveyReportTest";
import Survey from "@/pages/Survey";
import SurveyClosed from "@/pages/SurveyClosed";
import SurveyThankYou from "@/pages/SurveyThankYou";

export const AppRoutes = () => {
  console.log("[AppRoutes] Setting up application routes");
  
  return (
    <Routes>
      <Route element={<NavigationWrapper><Outlet /></NavigationWrapper>}>
        <Route index element={<Index />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/work" element={<Work />} />
        <Route path="/board" element={<Board />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/chatbot" element={<ChatBot />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/auth" element={<Auth />} />
        
        <Route path="/auth/reset-password" element={<Auth />} />
        <Route path="/auth/callback" element={<Auth />} />
        <Route path="/auth/verify" element={<Auth />} />
        
        <Route path="/article/:id" element={<ArticleDetail />} />
        <Route path="/survey" element={<SurveyClosed />} />
        <Route path="/survey/thank-you" element={<SurveyThankYou />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/profile"
          element={
            <ProtectedRoute>
              <AdminProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/articles"
          element={
            <ProtectedRoute>
              <AdminArticles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/articles/ai"
          element={
            <ProtectedRoute>
              <AdminAIArticles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/articles/list"
          element={
            <ProtectedRoute>
              <AdminArticlesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/gallery"
          element={
            <ProtectedRoute>
              <AdminGallery />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/image-studio"
          element={
            <ProtectedRoute>
              <AdminImageStudio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/contact-submissions"
          element={
            <ProtectedRoute>
              <AdminContactSubmissions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/membership-applications"
          element={
            <ProtectedRoute>
              <AdminMembershipApplications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/email-builder"
          element={
            <ProtectedRoute>
              <AdminEmailBuilder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/email-templates"
          element={
            <ProtectedRoute>
              <AdminEmailTemplates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/knowledge-base"
          element={
            <ProtectedRoute>
              <AdminKnowledgeBase />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/chat-history"
          element={
            <ProtectedRoute>
              <AdminChatHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/survey-results"
          element={
            <ProtectedRoute>
              <AdminSurveyResults />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/survey-report-test"
          element={
            <ProtectedRoute>
              <AdminSurveyReportTest />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};
